import React, { useState, useEffect, useRef } from 'react';
import { Printer, Upload } from "lucide-react";
import { useLanguage } from '../../StoreContext/LanguageContext';
import apiService from "../../config";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const LandBeneficiaryReport = ({ fetchButtonStatus }) => {
    const printRef = useRef(null);
    const handleEdit = () => {
    }
    //Send to Project Incharge
    const [showSendToProjectInchargeModal, setShowSendToProjectInchargeModal] = useState(false);
    const [usersProjectIncharge, setUsersProjectIncharge] = useState([]);
    const [loadingUsersProjectIncharge, setLoadingUsersProjectIncharge] = useState(false);
    const [selectedUserProjectIncharge, setSelectedUserProjectIncharge] = useState('');
    const [remarksProjectIncharge, setRemarksProjectIncharge] = useState('');
    const [selectedDocumentProjectIncharge, setSelectedDocumentProjectIncharge] = useState(null);
    const [sendingToProjectIncharge, setSendingToProjectIncharge] = useState(false);
    //Send to Tehsildar
    const [showSendToTehsildarModal, setShowSendToTehsildarModal] = useState(false);
    const [usersTehsildar, setUsersTehsildar] = useState([]);
    const [loadingUsersTehsildar, setLoadingUsersTehsildar] = useState(false);
    const [selectedUserTehsildar, setSelectedUserTehsildar] = useState('');
    const [remarksTehsildar, setRemarksTehsildar] = useState('');
    const [selectedDocumentTehsildar, setSelectedDocumentTehsildar] = useState(null);
    const [sendingToTehsildar, setSendingToTehsildar] = useState(false);
    const [projectId, setProjectId] = useState(null);
    const [proposalId, setProposalId] = useState(null);
    const { language, translations } = useLanguage();
    // Publication data
    const [publicationData, setPublicationData] = useState(null);
    const [loadingPublication, setLoadingPublication] = useState(false);
    const [fullName, setFullName] = useState('');
    const [designation , setDesignation] =useState('');
    const [showSignaturePad, setShowSignaturePad] = useState(false);
      const [pdfForSigning, setPdfForSigning] = useState(null);
      const [isViewerOpen, setIsViewerOpen] = useState(false);
      const [viewerFile, setViewerFile] = useState(null);
      const [previewUrl, setPreviewUrl] = useState(null);
      const {
        uploadStatus,
        uploadError,
        selectedSignDocument,
        resetSignatureState,
        setUploadStatus,
        setUploadError,
        signDocument
      } = useSignature();

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        setFullName(userData.full_name || '');
        setDesignation(userData.designation || '');
      }, []);

    // Project Id
    useEffect(() => {
        const getProjectInfo = () => {
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project (selectedProject):', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const projectId = user.data?.project_id || user.project_id;
                    const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
                    return {
                        id: projectId,
                        name: projectName
                    };
                } catch (e) {
                    console.error('Error parsing user data (userData):', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setProjectId(projectInfo.id);
        console.log('Current Project Info:', projectInfo);
    }, []);

    // Proposal id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

            if (currentProposal) {
                try {
                    return {
                        proposalId: currentProposal?.data?.default_proposal ||
                            currentProposal?.data?.proposal_id ||
                            currentProposal?.default_proposal ||
                            currentProposal?.proposal_id ||
                            null
                    }
                } catch (e) {
                    console.error('Error parsing current project data (getProposalInfo):', e);
                }
            }
            return { proposalId: null };
        };

        const proposalInfo = getProposalInfo();
        setProposalId(proposalInfo.proposalId);
        console.log('Current Project-Proposal Info:', proposalInfo);
    }, []);

    useEffect(() => {
        const fetchPublication = async () => {
            if (!projectId || !proposalId) return;

            try {
                setLoadingPublication(true);

                const res = await apiService.getPlotFamilyPublication(
                    projectId,
                    proposalId
                );

                console.log("📄 LandBeneficiary Publication:", res);

                // ✅ CORRECT handling
                if (res?.status === 200 && res?.data) {
                    setPublicationData(res.data);
                }
            } catch (error) {
                console.error("❌ Publication API error:", error);
            } finally {
                setLoadingPublication(false);
            }
        };

        fetchPublication();
    }, [projectId, proposalId]);

    // ✅ Edit Modal State
    const [showEditModal, setShowEditModal] = useState(false);
    const [loadingEdit, setLoadingEdit] = useState(false);

    // ✅ Default Content
    const DEFAULT_MAIN_CONTENT = `उपरोक्त विषयानुसार संदर्भ क्र. १, २ व ३ अन्वये मौजे कोरा तालुका शेगाव जिल्हा बुलढाणा येथील प्रकल्पग्रस्तांचे भूखंड वाटपाची प्रारुप यादी या कार्यालयास प्राप्त झालेली आहे. सदर प्रारुप यादी गावपातळीवर प्रसिद्ध करण्यात यावी. सदर यादी प्रसिद्धीनंतर प्रकल्पग्रस्तांनी आक्षेप असल्यास १० दिवसांत जिल्हा पुनर्वसन कार्यालय, बुलढाणा येथे सादर करावेत. आक्षेप नोंदविल्यानंतर अंतिम यादी प्रसिद्ध करण्यात येईल.`;

    // ✅ Edit Form State
    const [editForm, setEditForm] = useState({
        notification_no: "",
        date: "",
        subject: "",
        reference: "",
        default_content: DEFAULT_MAIN_CONTENT,
        copy_forwarded_to: "",
        email: ""
    });

    // ✅ Form Data for Display
    const [formData, setFormData] = useState({
        notification_no: "",
        date: "",
        subject: "",
        reference: "",
        default_content: "",
        copy_forwarded_to: "",
        email: ""
    });

    const USER_ROLES = {
        DATA_ENTRY: 14,
        DRO: 22,
        PROJECT_INCHARGE: 18,
        TEHSILDAR: 5
    };

    // Add this state declaration with your other useState calls:
    const [userRole, setUserRole] = useState(() => {
        try {
            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                return user.user_role || null;
            }
        } catch (error) {
            console.error("Error parsing user data:", error);
        }
        return null;
    });
    // ✅ Fetch Publication Data
    const fetchEditData = async () => {
        try {
            const data = await apiService.getPlotFamilyPublication(
                projectId,
                proposalId
            );

            if (data) {
                // 🔹 PAGE DISPLAY DATA
                setFormData({
                    notification_no: data.notification_no || "",
                    date: data.date || "",
                    subject: data.subject || "",
                    reference: data.reference || "",
                    default_content: data.default_content || DEFAULT_MAIN_CONTENT,
                    copy_forwarded_to: data.copy_forwarded_to || "",
                    email: data.email || ""
                });

                // 🔹 EDIT MODAL DATA
                setEditForm({
                    notification_no: data.notification_no || "",
                    date: data.date || "",
                    subject: data.subject || "",
                    reference: data.reference || "",
                    default_content: data.default_content || DEFAULT_MAIN_CONTENT,
                    copy_forwarded_to: data.copy_forwarded_to || "",
                    email: data.email || ""
                });
            }
        } catch (error) {
            console.error("GET PlotFamilyPublication error:", error);
        }
    };

    const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

 useEffect(() => {
  if (!selectedSignDocument) return;

  const postSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        console.error("Missing projectId or proposalId");
        return;
      }

      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "PrarupReport",      // 🔁 change per section
        selectedSignDocument   // ✅ signed PDF only
      );

      const sectionRes = await apiService.getSectionFile(
        projectId,
        proposalId,
        "PrarupReport"
      );

      if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
        setPreviewUrl(sectionRes.data[0].file_path);
      }

    } catch (error) {
      console.error("Error posting signed PDF:", error);
    }
  };

  postSignedPdf();
}, [selectedSignDocument]);

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "PrarupReport" // 🔁 change per section
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};

const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);

    useEffect(() => {
        if (projectId && proposalId) {
            fetchEditData();
        }
    }, [projectId, proposalId]);

    // ✅ Handle Update
    const handleUpdate = async () => {
        const payload = {
            project_id: projectId,
            proposal_id: proposalId,
            notification_no: editForm.notification_no,
            date: editForm.date,
            subject: editForm.subject,
            reference: editForm.reference,
            default_content: editForm.default_content,
            copy_forwarded_to: editForm.copy_forwarded_to,
            email: editForm.email
        };

        try {
            const res = await apiService.postAddUpdateLandPlotFamilyPublication(payload);

            // ✅ Check res.status instead of res.data.status
            if (res?.status === 200) {
                alert(res?.message || "Update Successful");
                setShowEditModal(false);

                // ✅ Reload latest data
                await fetchEditData();
            } else {
                alert(res?.message || "Update Failed");
            }
        } catch (error) {
            console.error("Update error:", error);
            alert("Update Failed: " + (error.message || "Unknown error"));
        }
    };

    const fetchUsersProjectIncharge = async () => {
        const role = 18;
        setLoadingUsersProjectIncharge(true);
        try {
            const response = await apiService.getAllUserRoleProjectIncharge(
                role,
                projectId,
                proposalId
            );

            if (response.status === 200 && response.data) {
                setUsersProjectIncharge(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersProjectIncharge([]);
            }
        } catch (error) {
            console.error('Error fetching Project Incharge users:', error);
            setUsersProjectIncharge([]);
        } finally {
            setLoadingUsersProjectIncharge(false);
        }
    };

    const fetchUsersTehsildar = async () => {
        const role = 5;
        setLoadingUsersTehsildar(true);
        try {
            const response = await apiService.getAllUserTehsildar(
                role,
                projectId,
                proposalId
            );

            if (response.status === 200 && response.data) {
                setUsersTehsildar(Array.isArray(response.data) ? response.data : []);
            } else {
                setUsersTehsildar([]);
            }
        } catch (error) {
            console.error(error);
            setUsersTehsildar([]);
        } finally {
            setLoadingUsersTehsildar(false);
        }
    };

    useEffect(() => {
        if (showSendToProjectInchargeModal) {
            fetchUsersProjectIncharge();
        }
    }, [showSendToProjectInchargeModal]);

    useEffect(() => {
        if (showSendToTehsildarModal) {
            fetchUsersTehsildar();
        }
    }, [showSendToTehsildarModal]);

    const handleSendToProjectIncharge = async () => {
        if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge) {
            alert('Please select user and upload document');
            return;
        }

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required');
            return;
        }

        setSendingToProjectIncharge(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksProjectIncharge);
            formData.append('usr_id', selectedUserProjectIncharge);
            formData.append('document', selectedDocumentProjectIncharge);

            const response = await apiService.postTrackingSendToProjectInchargeLand(formData);

            if (response.status === 200) {
                alert('Successfully sent to Project Incharge');
                setShowSendToProjectInchargeModal(false);
                setSelectedUserProjectIncharge('');
                setRemarksProjectIncharge('');
                setSelectedDocumentProjectIncharge(null);
                fetchButtonStatus();
            } else {
                alert('Failed to send to Project Incharge');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingToProjectIncharge(false);
        }
    };

    const handleSendToTehsildar = async () => {
        if (!selectedUserTehsildar || !selectedDocumentTehsildar) {
            alert('Please select user and upload document');
            return;
        }

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required');
            return;
        }

        setSendingToTehsildar(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksTehsildar);
            formData.append('usr_id', selectedUserTehsildar);
            formData.append('document', selectedDocumentTehsildar);

            const response = await apiService.postTrackingSendToTehsildarLand(formData);

            if (response.status === 200) {
                alert('Successfully sent to Tehsildar');
                setShowSendToTehsildarModal(false);
                setSelectedUserTehsildar('');
                setRemarksTehsildar('');
                setSelectedDocumentTehsildar(null);
                fetchButtonStatus();
            } else {
                alert('Failed to send to Tehsildar');
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSendingToTehsildar(false);
        }
    };
    const handlePrint = () => {
        const content = printRef.current.innerHTML;
        const win = window.open("", "", "width=900,height=700");
        win.document.write(`
    <html>
      <head>
        <title>Land Beneficiary Report</title>
        <style>
          body {
            font-family: "Noto Serif Devanagari", serif;
            padding: 40px;
            color: #000;
            font-size: 14px;
          }
          
          /* Table and Border styles */
          table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .border {
            border-width: 1px;
          }
          
          .border-black {
            border-color: #000;
          }
          
          .border-b {
            border-bottom-width: 1px;
          }
          
          /* Table specific borders */
          table, td {
            border: 1px solid #000;
          }
          
          /* Width */
          .w-full {
            width: 100%;
          }
          
          /* Flexbox layout */
          .flex {
            display: flex;
          }
          
          .justify-between {
            justify-content: space-between;
          }
          
          .justify-end {
            justify-content: flex-end;
          }
          
          /* Padding */
          .px-2 {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          
          .py-1 {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
          }
          
          .p-10 {
            padding: 2.5rem;
          }
          
          /* Margins */
          .mt-2 {
            margin-top: 0.5rem;
          }
          
          .mt-3 {
            margin-top: 0.75rem;
          }
          
          .mt-4 {
            margin-top: 1rem;
          }
          
          .mt-6 {
            margin-top: 1.5rem;
          }
          
          .mt-10 {
            margin-top: 2.5rem;
          }
          
          .ml-6 {
            margin-left: 1.5rem;
          }
          
          /* Text styles */
          .text-center {
            text-align: center;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-justify {
            text-align: justify;
          }
          
          .text-sm {
            font-size: 0.875rem;
          }
          
          .font-bold {
            font-weight: bold;
          }
          
          .leading-7 {
            line-height: 1.75rem;
          }
          
          /* Table styles */
          table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .border {
            border-width: 1px;
          }
          
          .border-black {
            border-color: #000;
          }
          
          /* Padding */
          .px-2 {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          
          .py-1 {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
          }
          
          .p-10 {
            padding: 2.5rem;
          }
          
          /* Margins */
          .mt-2 {
            margin-top: 0.5rem;
          }
          
          .mt-3 {
            margin-top: 0.75rem;
          }
          
          .mt-4 {
            margin-top: 1rem;
          }
          
          .mt-6 {
            margin-top: 1.5rem;
          }
          
          .mt-10 {
            margin-top: 2.5rem;
          }
          
          .ml-6 {
            margin-left: 1.5rem;
          }
          
          /* Text styles */
          .text-center {
            text-align: center;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-justify {
            text-align: justify;
          }
          
          .text-sm {
            font-size: 0.875rem;
          }
          
          .font-bold {
            font-weight: bold;
          }
          
          .leading-7 {
            line-height: 1.75rem;
          }
          
          /* Table styles */
          table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .border {
            border-width: 1px;
          }
          
          .border-black {
            border-color: #000;
          }
          
          /* List styles */
          .list-decimal {
            list-style-type: decimal;
          }
          
          .ml-6 {
            margin-left: 1.5rem;
          }
          
          /* Other utility classes */
          .mt-2 { margin-top: 0.5rem; }
          .mt-3 { margin-top: 0.75rem; }
          .mt-4 { margin-top: 1rem; }
          .mt-6 { margin-top: 1.5rem; }
          .mt-10 { margin-top: 2.5rem; }
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .text-justify { text-align: justify; }
          .text-sm { font-size: 0.875rem; }
          .font-bold { font-weight: bold; }
          .leading-7 { line-height: 1.75rem; }
        </style>
      </head>
      <body>${content}</body>
    </html>
  `);
        win.document.close();
        win.focus();
        win.print();
        win.close();
    };

    if (loadingPublication) {
        return <div className="p-6 text-center font-bold">डेटा लोड होत आहे...</div>;
    }


    return (
        <div className="p-6 bg-gray-100">
                <div className="flex justify-between items-center mb-4">
                    <div className="flex gap-2">
                {/* <button className="relative">
                  <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                    <Upload size={18} />
                    <span>Upload Signature</span>
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      className="hidden"
                      onChange={handleUploadedFile}
                    />
                  </label>
                </button>
      
                <button
                onClick={handleViewSignedPdf}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                <Printer size={18} />
                <span>View Signed PDF</span>
              </button> */}

                <button
                    onClick={handlePrint}
                    className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
                >
                    {translations[language].Print}
                </button>
                
                <button
                    onClick={() => setShowEditModal(true)}
                    className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-lg"
                >
                    {translations[language].edit}
                </button>
                </div>

                <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
                    <button
                    onClick={() => setShowSendToTehsildarModal(true)}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                >
                    {translations[language]?.punarSendToTehsilar}
                </button>

                <button
                    onClick={() => setShowSendToProjectInchargeModal(true)}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
                >
                    {translations[language]?.SendToProjectIncharge}
                </button>
                </div>
            </div>

            {/* LETTER */}
            <div
                ref={printRef}
                className="bg-white p-10 max-w-4xl mx-auto shadow"
            >
                {/* HEADER */}
                <div className="text-center font-bold leading-7">
                    महाराष्ट्र शासन <br />
                    जिल्हा पुनर्वसन विभाग <br />
                    जिल्हाधिकारी कार्यालय, बुलढाणा
                </div>

                {/* WEBSITE / EMAIL / DATE */}
                <table className="w-full text-sm mt-4 border border-black">
                    <tbody>
                        <tr>
                            <td className="border border-black px-2 py-1">
                                website : www.buldhana.nic.in
                            </td>
                            <td className="border border-black px-2 py-1">
                                e-mail : {formData.email || "—"}
                            </td>
                            <td className="border border-black px-2 py-1">
                                दिनांक : {formData.date ? new Date(formData.date).toLocaleDateString("hi-IN") : "—"}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* JAWAK NO */}
                <div className="mt-3 text-sm">
                    जावक क्र. : {formData.reference || "—"}
                </div>

                {/* TO */}
                <div className="mt-6 text-sm">
                    <p>
                        <b>प्रति,</b> <br />
                        तहसीलदार <br />
                        शेगाव
                    </p>
                </div>

                {/* SUBJECT */}
                <div className="mt-4 text-sm">
                    <b>विषय :</b> {formData.subject || "—"}
                </div>

                {/* REFERENCE */}
                <div className="mt-2 text-sm">
                    <b>संदर्भ :</b>
                    <ol className="list-decimal ml-6">
                        <li>
                            कार्यकारी अभियंता, जिगाव प्रकल्प धरण व पुनर्वसन विभाग,
                            शेगाव यांचे पत्र.
                        </li>
                        <li>
                            मौजे कोरा ता. शेगाव जि. बुलढाणा येथील संयुक्त मोजणी अहवाल.
                        </li>
                        <li>
                            मौजे कोरा ता. शेगाव जि. बुलढाणा येथील भूसंपादन अहवाल.
                        </li>
                    </ol>
                </div>

                {/* BODY */}
                <p className="mt-6 text-sm leading-7 text-justify">
                    {formData.default_content || DEFAULT_MAIN_CONTENT}
                </p>

                {/* FOOTER */}
                <div className="mt-10 text-right text-sm">
                    <div className="mt-10 text-right signature">
                    <div className="font-bold">{fullName}</div>
                    <div>{designation}</div>
                    </div>
                    <p>बुलढाणा</p>
                </div>

                {/* COPY */}
                <div className="mt-10 text-sm">
                    <b>प्रतिलिपी :</b>
                    <p className="mt-2">
                        {formData.copy_forwarded_to || "कार्यकारी अभियंता, जिगाव प्रकल्प धरण व पुनर्वसन विभाग, शेगाव."}
                    </p>
                </div>
            </div>

            {/* ✅ EDIT MODAL */}
            {showEditModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl w-full max-w-3xl p-6 relative max-h-[90vh] overflow-y-auto">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-bold">संपादन करा</h2>
                            <button onClick={() => setShowEditModal(false)}>✕</button>
                        </div>

                        {/* Proposal Details */}
                        <div className="text-center mb-4">
                            <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                                Proposal Details
                            </span>
                        </div>

                        <div className="grid grid-cols-3 gap-4">
                            {/* जावक क्र. */}
                            <div className="group">
                                <label className="block font-semibold text-gray-700 mb-2 text-base">
                                    जावक क्र. :
                                </label>
                                <input
                                    value={editForm.reference}
                                    onChange={(e) => setEditForm({ ...editForm, reference: e.target.value })}
                                    placeholder="जावक क्र."
                                    className="w-full border p-2 rounded"
                                />
                            </div>

                            {/* date */}
                            <div className="group">
                                <label className="block font-semibold text-gray-700 mb-2 text-base">
                                    date :
                                </label>
                                <input
                                    type="date"
                                    value={editForm.date}
                                    onChange={(e) => setEditForm({ ...editForm, date: e.target.value })}
                                    className="w-full border p-2 rounded"
                                />
                            </div>

                            {/* email */}
                            <div className="group">
                                <label className="block font-semibold text-gray-700 mb-2 text-base">
                                    email :
                                </label>
                                <input
                                    value={editForm.email}
                                    onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
                                    placeholder="email"
                                    className="w-full border p-2 rounded"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 gap-4 mt-4">
                            {/* विषय */}
                            <div className="group">
                                <label className="block font-semibold text-gray-700 mb-2 text-base">
                                    विषय :
                                </label>
                                <input
                                    value={editForm.subject}
                                    onChange={(e) => setEditForm({ ...editForm, subject: e.target.value })}
                                    placeholder="विषय"
                                    className="w-full border p-2 rounded"
                                />
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="text-center mt-6 mb-2">
                            <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                                Main Content
                            </span>
                        </div>

                        <textarea
                            rows={8}
                            value={editForm.default_content}
                            onChange={(e) => setEditForm({ ...editForm, default_content: e.target.value })}
                            className="w-full border rounded p-3 text-sm"
                        />

                        {/* प्रतिलिपी Content */}
                        <div className="text-center mt-6 mb-2">
                            <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                                प्रतिलिपी
                            </span>
                        </div>

                        <textarea
                            rows={4}
                            value={editForm.copy_forwarded_to}
                            onChange={(e) => setEditForm({ ...editForm, copy_forwarded_to: e.target.value })}
                            className="w-full border rounded p-3 text-sm"
                        />

                        {/* Footer Buttons */}
                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                onClick={() => setShowEditModal(false)}
                                className="px-4 py-2 border rounded"
                            >
                                रद्द करा
                            </button>

                            <button
                                onClick={handleUpdate}
                                className="px-4 py-2 bg-blue-600 text-white rounded"
                            >
                                बदल जतन करा
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Send to Project Incharge Model */}
            {showSendToProjectInchargeModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="space-y-4">
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.SelectProjectIncharge || 'Select Project Incharge'} *
                                    </label>
                                    <select
                                        value={selectedUserProjectIncharge}
                                        onChange={(e) => setSelectedUserProjectIncharge(e.target.value)}
                                        disabled={loadingUsersProjectIncharge}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingUsersProjectIncharge ? (translations[language]?.LoadingUsers || 'Loading Users...') : (translations[language]?.SelectUser || 'Select User')}
                                        </option>
                                        {usersProjectIncharge.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks || 'Remarks'}
                                    </label>
                                    <textarea
                                        value={remarksProjectIncharge}
                                        onChange={(e) => setRemarksProjectIncharge(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Upload Document *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setSelectedDocumentProjectIncharge(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocumentProjectIncharge && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    Selected: {selectedDocumentProjectIncharge.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocumentProjectIncharge.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocumentProjectIncharge.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocumentProjectIncharge?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocumentProjectIncharge);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>

                                                    </>
                                                )}
                                            </div>
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document signed successfully!
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setShowSendToProjectInchargeModal(false);
                                        setSelectedDocumentProjectIncharge(null);
                                        resetSignatureState();
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToProjectIncharge}
                                >
                                    {translations[language]?.Cancel || 'Cancel'}
                                </button>

                                <button
                                    onClick={handleSendToProjectIncharge}
                                    disabled={sendingToProjectIncharge || !selectedUserProjectIncharge || !selectedDocumentProjectIncharge}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToProjectIncharge ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.Sending || 'Sending...'}
                                        </>
                                    ) : (
                                        <>
                                            <div className="mr-2 h-4 w-4" />
                                            {translations[language]?.send || 'Send'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Send to Tehsildar Model */}
            {showSendToTehsildarModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="space-y-4">
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.SelectTehsildar || 'Select Tehsildar'} *
                                    </label>
                                    <select
                                        value={selectedUserTehsildar}
                                        onChange={(e) => setSelectedUserTehsildar(e.target.value)}
                                        disabled={loadingUsersTehsildar}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingUsersTehsildar ? (translations[language]?.LoadingUsers || 'Loading Users...') : (translations[language]?.SelectUser || 'Select User')}
                                        </option>
                                        {usersTehsildar.map((user) => (
                                            <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks || 'Remarks'}
                                    </label>
                                    <textarea
                                        value={remarksTehsildar}
                                        onChange={(e) => setRemarksTehsildar(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Upload Document *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setSelectedDocumentTehsildar(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                    {selectedDocumentTehsildar && (
                                        <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                            <div className="flex items-center justify-between mb-2">
                                                <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                    Selected: {selectedDocumentTehsildar.name}
                                                </p>
                                                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                    {(selectedDocumentTehsildar.size / 1024 / 1024).toFixed(2)} MB
                                                </span>
                                            </div>
                                            <div className="flex gap-2">
                                                {selectedDocumentTehsildar.type === 'application/pdf' && (
                                                    <>
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                if (selectedDocumentTehsildar?.type === 'application/pdf') {
                                                                    setPdfForSigning(selectedDocumentTehsildar);
                                                                    setShowSignaturePad(true);
                                                                }
                                                            }}
                                                            disabled={uploadStatus === 'uploading'}
                                                            className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                        >
                                                            {uploadStatus === 'uploading' ? (
                                                                <>
                                                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                    Signing...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                    </svg>
                                                                    Sign Doc
                                                                </>
                                                            )}
                                                        </button>

                                                    </>
                                                )}
                                            </div>
                                            {uploadStatus === 'success' && (
                                                <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                    ✅ Document signed successfully!
                                                </div>
                                            )}
                                            {uploadStatus === 'error' && uploadError && (
                                                <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                    ❌ {uploadError}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setShowSendToTehsildarModal(false);
                                        setSelectedDocumentTehsildar(null);
                                        resetSignatureState();
                                    }}
                                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToTehsildar}
                                >
                                    {translations[language]?.Cancel || 'Cancel'}
                                </button>

                                <button
                                    onClick={handleSendToTehsildar}
                                    disabled={sendingToTehsildar || !selectedUserTehsildar || !selectedDocumentTehsildar}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToTehsildar ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.Sending || 'Sending...'}
                                        </>
                                    ) : (
                                        <>
                                            <div className="mr-2 h-4 w-4" />
                                            {translations[language]?.send || 'Send'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

             {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      // ✅ ONLY sign here
      signDocument(pdfForSigning, signaturesArray);

      setPdfForSigning(null);
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

{isViewerOpen && viewerFile && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

      <div className="flex justify-between items-center px-4 py-2 border-b">
        <h3 className="text-lg font-semibold">Signed Document</h3>
        <button
          onClick={() => setIsViewerOpen(false)}
          className="text-xl font-bold"
        >
          ✕
        </button>
      </div>

      <iframe
        src={viewerFile}
        title="Signed PDF Viewer"
        className="w-full h-full"
      />
    </div>
  </div>
)}

{(uploadStatus === "signing" || uploadStatus === "uploading") && (
  <SignatureLoader
    text={
      uploadStatus === "signing"
        ? "Applying digital signature…"
        : "Uploading signed document…"
    }
  />
)}
        </div>
    );
};

export default LandBeneficiaryReport;
